<div class="row mt-2">
  <h1 class="text-uppercase">camera</h1>
  <div class="camera-list col-12">
    <button class="btn camera-item"
      *ngFor="let c of cameras"
      [class.active]="currentCamera?.id === c.id"
      (click)="selectCamera(c)">
      {{ c.posName }}
    </button>
  </div>
</div>
